/** @format */

import { InputText } from "primereact/inputtext";

const ShortAnswerTemplate = ({ setSurvey, questionIndex, name }) => (
  <div className='field'>
    <InputText
      value={name}
      onChange={(e) => {
        let value = e.target.value;
        setSurvey((draft) => {
          let currentQuestion = draft.questionRequestDTOS[questionIndex];
          currentQuestion.name = value;
        });
      }}
    />
  </div>
);

export default ShortAnswerTemplate;
